<template>
  <div class="container">
    <div class="row mb-3">
      <div class="col-12">
        <h1>OSRS Genie Roadmap</h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <h1 class="mb-4">Roadmap</h1>

                <p>Below outlines the roadmap of feature development for this site:</p>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h2>DPS Calculator</h2>
              </div>

              <div class="col-10 offset-2">
                <ul class="text-left">
                  <li>Set Bonuses</li>
                  <li>Prayer Drain</li>
                  <li>Recent Items / Popular Items per slot</li>
                  <li>Gear Optimizer</li>
                  <li>Special Attack & PVP - Credit: <a href="https://github.com/LovinLifee">LovinLifee</a></li>
                  <li>EXP/hr</li>
                  <li>Asset Optimization</li>
                </ul>
              </div>
            </div>

            <hr>

            <div class="row">
              <div class="col-12 mb-3">
                <h2>Gear Upgrades</h2>
              </div>

              <div class="col-10 offset-2">
                <ul class="text-left">
                  <li>Available Gear Upgrades</li>
                  <li>Drop Info & Monster Statistics</li>
                  <li>Optimal Gear for hunting upgrades</li>
                  <li>BiS Gear Options (Best In Slot)</li>
                  <li>EXP/hr</li>
                </ul>
              </div>
            </div>

            <hr>

            <div class="row mb-3">
              <div class="col-12">
                <h2>Training Calculator</h2>
              </div>

              <div class="col-10 offset-2">
                <ul class="text-left">
                  <li>Optimal EXP/hr</li>
                  <li>Optimal GP/hr</li>
                  <li>Optimal Slayer Points/hr</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h1 class="mb-4">Release Notes</h1>

                <i>Coming Soon!</i>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h1 class="mb-4">Quick Question</h1>


                <div id="chatbotContainer1" style="height: 500px"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Roadmap",
    mounted() {
      let elem = document.querySelector('#chatbotContainer1');
      let cb = new Chatbot(elem, 43)
    }
  }
</script>

<style scoped>
  .card {
    border-color: #3F3529;
  }

  .card-body {
    color: black;
    font-size: 1.3rem;
    background: #5B5545;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Roadmap.vue